export const DOCUMENT = "DOCUMENT";
export const DOCUMENT_SUCCESS = "DOCUMENT_SUCCESS";
export const DOCUMENT_FAILED = "DOCUMENT_FAILED";

export const ADD_DOCUMENT = "ADD_DOCUMENT";
export const ADD_DOCUMENT_SUCCESS = "ADD_DOCUMENT_SUCCESS";
export const ADD_DOCUMENT_FAILED = "ADD_DOCUMENT_FAILED";

export const UPDATE_DOCUMENT = "UPDATE_DOCUMENT";
export const UPDATE_DOCUMENT_SUCCESS = "UPDATE_DOCUMENT_SUCCESS";
export const UPDATE_DOCUMENT_FAILED = "UPDATE_DOCUMENT_FAILED";